import { useToastNotification } from '@/hooks';

export const useDownloadPdf = () => {
  const { showToast } = useToastNotification();

  const downloadPdf = (pdfData: string | null, downloadName: string) => {
    if (!pdfData) {
      showToast({
        severity: 'error',
        detail: 'PDF No contiene información',
      });
      return;
    }

    showToast({
      severity: 'info',
      detail: 'Comenzando descarga...',
    });

    const byteCharacters = atob(pdfData.replace(/-/g, '+').replace(/_/g, '/'));
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${downloadName}.pdf`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);

    showToast({
      severity: 'success',
      detail: 'Descarga completa',
    });
  };

  return { downloadPdf };
};
